import { render, staticRenderFns } from "./AdvanceCreditInformationTab.vue?vue&type=template&id=dc490dea&scoped=true&"
import script from "./AdvanceCreditInformationTab.vue?vue&type=script&lang=ts&"
export * from "./AdvanceCreditInformationTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc490dea",
  null
  
)

export default component.exports